import { Component } from '@angular/core';
import { Card } from 'primeng/card';

@Component({
  selector: 'cmg-clear2-ui-login-failed',
  templateUrl: './login-failed.component.html',
  styleUrls: ['./login-failed.component.scss'],
  imports: [Card],
})
export class LoginFailedComponent {
  title = 'Login failed';
}
